import { Button, Card, Input, Tooltip } from "antd";
import axios from "axios";
import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Link, withRouter } from "react-router-dom";
import { Alert } from "rsuite";
import { Context } from "../../Context";
import infoIcon from "../../assets/images/info-icon.png";
import statisfi_back_logo from "../../assets/images/satisfi_black.svg";
import constants from "../../constants";
import fieldConstants from "../../fieldConstants";
import services from "../../services";
import { TimeoutContext } from "../../services/Contexts/TimeoutContext";
import { Input2 } from "../common";
import { Loader } from "../index";

import "../../assets/styles/two_ui_ctrl.css";

const hostname = window.location.hostname;
const recaptchaRef = React.createRef();
const formFields = [
	{
		name: "email",
		label: "Email Address",
		type: "email",
		class: "single-element",
		invalidMsg: "This is not valid email address",
	},
	{
		name: "password",
		label: "Password",
		type: "password",
		class: "single-element",
		invalidMsg:
			"The email id and password don't match. Click on forgot password to change",
	},
];

const api = services.api;

class SignIn extends React.Component {
	static contextType = Context;
	constructor(props) {
		super(props);
		this.state = {
			formData: {
				firstName: null,
				lastName: null,
				email: null,
				password: null,
				otp: null,
			},
			valid: {
				email: null,
				password: null,
				valid: null,
			},
			loginError: null,
			showPassword: false,
			recaptchaValidation: null,
			reCaptchaValue: null,
			loading: true,
			pageRedirectionLoading: false,
			disableButton: false,
			otp: null,
			otp_sent: false,
			otp_validated: false,
			req_type: null,
			enableResendBtn: true,
			incorrect_otp: false,
			otp_errMsg: null,
			disableContinue: false,
			isCodeIncorrect: false,
			alertTime: 300000,
		};
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {
		if (window.localStorage.getItem("user_token")) {
			this.props.history.push("/");
		}
		this.setState({
			loading: false,
		});
	}

	onLoaderStart = () => {
		this.setState({ loading: true });
	};

	onLoadingComplete = () => {
		this.setState({ loading: false });
	};

	onReLogin = () => {
		this.setState({
			otp_sent: false,
			disableButton: false,
			otp: null,
			otp_validated: false,
			req_type: null,
			enableResendBtn: true,
			incorrect_otp: false,
			otp_errMsg: null,
			disableContinue: false,
			isCodeIncorrect: false,
		});
		Alert.closeAll();
	};

	/**
	 * Updates the form data state with the entered input value.
	 *
	 * @param {string} fieldName - The name of the input field.
	 * @param {string} value - The entered value for the input field.
	 * @returns {void}
	 */
	inputEntered = (fieldName, value) => {
		const values = { ...this.state.formData };
		values[fieldName] = value ? value : "";
		this.setState({
			formData: { ...values },
			loginError: null,
		});
	};

	/**
	 * Handles the change event for the OTP input field.
	 * @param {Event} event - The event object.
	 */
	onChangeOtp = (event) => {
		this.setState({ otp: event.target.value });
	};

	/**
	 * Updates the valid flag for a given field.
	 * @param {string} fieldName - The name of the field.
	 * @param {boolean} value - The value of the field.
	 */
	captureValidFlag = (fieldName, value) => {
		let values = {
			...this.state.valid,
		};
		values[fieldName] = value;
		this.setState({
			valid: {
				...values,
				valid: values.email && values.password,
			},
		});
	};

	/**
	 * Handles the form submission for the login/sign-in process.
	 * @param {Event} event - The event object triggered by the form submission.
	 * @param {string} action_data - The action data associated with the form submission.
	 * @returns {Promise<void>} - A promise that resolves when the form submission is complete.
	 */
	onSubmit = async (event) => {
		this.setState({ disableButton: true });
		let data = {};
		if (this.state.otp_sent) {
			data = {
				email: this.state.formData.email.toLowerCase(),
				otp: this.state.otp,
			};
		} else {
			data = {
				identifier: this.state.formData.email.toLowerCase(),
				password: this.state.formData.password,
				recaptchaValue: this.state.reCaptchaValue,
			};
		}

		try {
			event.preventDefault();
			// call the sign-in api
			if (
				!(constants.captcha_whitelist.includes(hostname)
					? !this.state.valid.valid || !this.state.recaptchaValidation
					: !this.state.valid.valid)
			) {
				let urlToBeCalled = "";
				if (this.state.otp_sent) {
					// Two factor authentication
					if (this.state.otp) {
						urlToBeCalled = constants.otpValidation;
						this.setState({ req_type: "OTP_VALIDATION" });
						this.onLoaderStart();
					} else {
						return Alert.error(
							"OTP code is mandatory.",
							constants.alertDuration,
						);
					}
				} else {
					urlToBeCalled = constants.userSignIn;
					this.setState({ req_type: "PWD_VALIDATION" });
				}
				const response = await api.post(urlToBeCalled, data);

				if (response.status !== 200) {
					this.setState({ disableButton: false });
					Alert.error("Unable to login");
					if (this.state.req_type === "OTP_VALIDATION") {
						this.setState({ incorrect_otp: true });
					}
					this.onLoadingComplete();
				} else {
					if (this.state.req_type === "PWD_VALIDATION") {
						if (response.data.user.enterprise !== null) {
							console.log(
								"TFA enabled status : ",
								response.data.user.enterprise.tfa_enabled,
							);
							if (!response.data.user.enterprise.tfa_enabled) {
								console.log("Dashboard redirection called ...");
								this.pageRedirection(response);
							} else {
								this.setState({ otp_sent: true });
								if (!response.data.tfa.enable_resend) {
									this.setState({ enableResendBtn: false });
								}
							}
						} else {
							console.log(
								"Enterprise not enabled for this user account so we redirect to Dashboard ...",
							);
							this.pageRedirection(response);
						}
					} else if (this.state.req_type === "OTP_VALIDATION") {
						this.pageRedirection(response);
					} else {
						console.log("Unhandled exception so we redirect to Dashboard ...");
						this.pageRedirection(response);
					}

					this.onLoadingComplete();
				}
			}
			this.setState({ disableButton: false });
		} catch (error) {
			this.onLoadingComplete();
			console.log("error", error.response);
			if (error.response?.data.message[0].messages[0].disable_btn) {
				this.setState({ disableContinue: true });
			}
			if (
				error.response &&
				error.response.data.message[0].messages[0].status === "IC"
			) {
				this.setState({ isCodeIncorrect: true });
			}
			const value = localStorage.getItem("popUpValue");
			if (constants.captcha_whitelist.includes(hostname)) {
				recaptchaRef.current.reset();
			}
			if (value === null) {
				if (error.response?.data.message[0].messages[0].disable_btn) {
					Alert.error(
						error?.response ? (
							<p>
								Due to too many invalid login attempts, your account is locked.
								Please contact{" "}
								<a href="mailto:me-support@satisfilabs.com">Support</a>
							</p>
						) : (
							null || "Something went wrong"
						),
						this.state.alertTime,
						() => localStorage.removeItem("popUpValue"),
					);
				} else {
					localStorage.setItem("popUpValue", "1");
					Alert.error(
						error?.response
							? error.response.data.message[0].messages[0].message
							: null || "Something went wrong",
						constants.alertDuration,
						() => localStorage.removeItem("popUpValue"),
					);
				}
			} else if (
				error.response?.data.message[0].messages[0].disable_btn ||
				(error.response &&
					error.response.data.message[0].messages[0].status === "IC")
			) {
				if (
					error.response &&
					error.response.data.message[0].messages[0].status === "IC"
				) {
					Alert.error(
						error?.response
							? error.response.data.message[0].messages[0].message
							: null || "Something went wrong",
						constants.alertDuration,
						() => localStorage.removeItem("popUpValue"),
					);
				} else if (error.response?.data.message[0].messages[0].disable_btn) {
					Alert.error(
						error?.response ? (
							<p>
								Due to too many invalid login attempts, your account is locked.
								Please contact{" "}
								<a href="mailto:me-support@satisfilabs.com">Support</a>
							</p>
						) : (
							null || "Something went wrong"
						),
						this.state.alertTime,
						() => localStorage.removeItem("popUpValue"),
					);
				}
			}

			this.setState({
				recaptchaValidation: false,
				disableButton: false,
			});
		}
	};

	forgotPassword = () => {
		console.log("clicked forgot password");
	};

	onChangeRecaptcha = (value) => {
		this.setState({
			recaptchaValidation: true,
			reCaptchaValue: value,
		});
	};

	onExpiredRecaptcha = () => {
		this.setState({
			recaptchaValidation: false,
		});
	};

	onErrorRecaptcha = () => {
		this.setState({
			recaptchaValidation: false,
		});
	};

	setCaretPosition = (ctrl, pos) => {
		// Modern browsers
		if (ctrl.setSelectionRange) {
			ctrl.focus();
			ctrl.setSelectionRange(pos, pos);

			// IE8 and below
		} else if (ctrl.createTextRange) {
			const range = ctrl.createTextRange();
			range.collapse(true);
			range.moveEnd("character", pos);
			range.moveStart("character", pos);
			range.select();
		}
	};

	showPasswordHandler = () => {
		this.setState({ showPassword: !this.state.showPassword }, () => {
			setTimeout(() => {
				const input = document.getElementById("custom-css-outlined-input_1");
				this.setCaretPosition(input, input.value.length);
			}, 0);
		});
	};

	pageRedirection = async (response) => {
		this.setState({ loading: true, pageRedirectionLoading: true });
		//storing the user_token
		window.localStorage.setItem("id", response.data.user.id);
		window.localStorage.setItem("user_token", response.data.jwt);
		window.localStorage.setItem("username", response.data.user.username);
		window.localStorage.setItem(
			"firstname",
			response.data.user.firstname || response.data.user.username,
		);
		window.localStorage.setItem("email", response.data.user.email);
		response.data.user.enterprise
			? window.localStorage.setItem(
					"enterprise_id",
					response.data.user.enterprise.id,
				)
			: null;
		if (response.data.user.enterprise) {
			window.localStorage.setItem(
				"org_name",
				response.data.user.enterprise.org_name,
			);
		} else {
			window.localStorage.setItem("org_name", "Enterprise Name");
		}

		const claims_req = {
			method: "GET",
			url: constants.claims,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${response.data.jwt}`,
			},
		};

		// check for claims
		const claims_resp = await axios(claims_req);

		let MAIN_DASH = true;
		let DNS_VALIDATION = true;

		if ([200, 201].includes(claims_resp.status)) {
			if (claims_resp.data?.data && claims_resp.data.data.length > 0) {
				for (const claim of claims_resp.data.data) {
					if (claim.feature === "MAIN_DASH" && claim.disabled) {
						MAIN_DASH = false;
					} else if (claim.feature === "DNS_VALIDATION" && claim.disabled) {
						DNS_VALIDATION = false;
					}
				}
			}
		}

		/**
		 * set claims in localStorage
		 */
		window.localStorage.setItem("MAIN_DASH", MAIN_DASH.toString());
		window.localStorage.setItem("DNS_VALIDATION", DNS_VALIDATION.toString());

		if (response.data.user.enterprise) {
			window.localStorage.setItem(
				"factcube_enabled",
				response.data.user.enterprise.factcube_enabled !== undefined
					? response.data.user.enterprise.factcube_enabled
					: false,
			);

			window.localStorage.setItem(
				"dash_currency",
				response.data.user.enterprise.currency !== null
					? response.data.user.enterprise.currency
					: "$",
			);
		}

		const stage = response.data.user.stage;

		if (stage !== 0) {
			await this.context.getenterpriseFunc();
			await this.context.resetGlobalContextFunc();
			await this.context.getRandomProducts();
			await this.context.getModeratorInfoFunc();
			await this.context.getUserRolesInfoFunc();
		}

		this.setState({ loading: false, pageRedirectionLoading: false });

		if (this.props.location.state?.from.pathname) {
			const relativePath =
				this.props.location.state.from.pathname +
				this.props.location.state.from.search;
			this.props.history.push(relativePath);
		} else {
			// user has selected the enterprise goals
			const account_status =
				response.data.user.enterprise.enterprise_account_status;
			const parameters = this.props.location?.search
				? this.props.location.search.replace("?", "")
				: "";
			const parentUrl = this.props.match.params.id;

			console.log(
				" :477 | SignIn | pageRedirection= | account_status:",
				account_status,
			);
			if (account_status) {
				if (account_status.toLowerCase() === "archived") {
					Alert.warning("Your account is in archive state. Can't login");
				} else if (account_status.toLowerCase() === "deleted") {
					Alert.warning("User doesn't exist!");
				} else {
					const existingScript = document.getElementById("satisfiScript");
					if (
						!existingScript &&
						Number(window.localStorage.getItem("enterprise_id")) > 0 &&
						constants.all_domains.includes(window.location.hostname)
					) {
						const script = document.createElement("script");
						script.src = "https://chat.satis.fi/popup/embedder?popupId=18836";
						script.id = "satisfiScript";
						document.body.appendChild(script);
					}
					// const whatfixScript = document.getElementById("whatfix");
					// const whatfixScriptTag =
					// 	window.location.hostname !== constants.all_domains[1]
					// 		? constants.whatfix_url[0]
					// 		: constants.whatfix_url[1];
					// if (!whatfixScript) {
					// 	const w_script = document.createElement("script");
					// 	w_script.src = whatfixScriptTag;
					// 	w_script.language = "javascript";
					// 	w_script.async = "true";
					// 	w_script.type = "text/javascript";
					// 	w_script.id = "whatfix";
					// 	w_script.crossorigin = "";
					// 	document.body.appendChild(w_script);
					// }
					if (parentUrl && parentUrl.length > 0) {
						this.props.history.push({
							pathname: `/${parentUrl}`,
							state: { id: "myPlan", data: parameters },
						});
					} else {
						if (window.localStorage.getItem("source") === "shopify") {
							this.props.history.push({
								pathname: "/settings/app-integrations/shopify",
								search: window.localStorage.getItem("search"),
							});
						} else this.props.history.push({ pathname: "/" });

						Alert.success(
							`Welcome to Marketing Engine, ${window.localStorage.getItem("firstname")}.`,
						);
						window.localStorage.setItem("source", "");
					}
				}
			} else {
				this.props.history.push("/");
				Alert.success(
					`Welcome to Marketing Engine, ${window.localStorage.getItem("firstname")}.`,
				);
			}
		}
	};

	onResendOTP = async (e) => {
		this.onLoaderStart();
		const data = {
			email: this.state.formData.email.toLowerCase(),
		};
		try {
			e.preventDefault();
			const response = await api.post(constants.resendOTP, data);
			if (response.status !== 200) {
				this.setState({ disableButton: false });
				Alert.error(response.error, constants.alertDuration);
				this.onLoadingComplete();
			} else {
				if (!response.data.tfa.enable_resend) {
					this.setState({ enableResendBtn: false });
				}

				Alert.success("Email sent!. Enter the code");
				this.onLoadingComplete();
			}
		} catch (error) {
			this.onLoadingComplete();
			Alert.error(
				error.response.data.message[0].messages[0].message ||
					"Something went wrong",
				constants.alertDuration,
				() => localStorage.removeItem("popUpValue"),
			);
		}
	};

	render() {
		const captchaControls = () => {
			return (
				<form onSubmit={this.onSubmit} autoComplete="on">
					{formFields.map((item, index) => (
						<Input2
							containerClass=""
							type={item.type}
							name={item.name}
							placeholder={item.label}
							value={this.state.formData[item.name]}
							onChange={this.inputEntered}
							key={item.name}
							autoComplete={
								item.name === "password" ? "current-password" : "email"
							}
							id={`custom-css-outlined-input_${index}`}
							getValid={this.captureValidFlag}
							showPassword={this.state.showPassword}
							handleClickShowPassword={this.showPasswordHandler}
						/>
					))}
					<div style={{ height: 20 }}>
						{this.state.loginError ? (
							<span className="error-msg">{this.state.loginError}</span>
						) : null}
					</div>

					<div
						className={`captcha-container ${
							constants.captcha_whitelist.includes(hostname)
								? "recaptcha-container"
								: ""
						}`}
					>
						{constants.captcha_whitelist.includes(hostname) && (
							<ReCAPTCHA
								sitekey={constants.recaptchaSitekey}
								onChange={this.onChangeRecaptcha}
								onExpired={this.onExpiredRecaptcha}
								onErrored={this.onErrorRecaptcha}
								size="normal"
								ref={recaptchaRef}
							/>
						)}
						<Link to="/forgot-password" className="forgot">
							Forgot password?
						</Link>
					</div>

					<button
						className="btn btn-primary-cta signin-button"
						type="submit"
						disabled={
							this.state.disableButton ||
							constants.captcha_whitelist.includes(hostname)
								? !this.state.valid.valid || !this.state.recaptchaValidation
								: !this.state.valid.valid
						}
					>
						Sign In
					</button>
				</form>
			);
		};

		const tfaControlGrid = () => {
			return (
				<Card
					title="Two-Factor Authentication"
					headStyle={{ fontWeight: "bold" }}
					bodyStyle={{ textAlign: "left" }}
				>
					<p>{fieldConstants.tfa_info}</p>
					<br />
					<p style={{ width: "35%" }}>
						Two-Factor Code &nbsp; &nbsp;
						<Tooltip title={fieldConstants.tfa_tooltip}>
							<img
								loading="lazy"
								src={infoIcon}
								style={{ cursor: "pointer", marginLeft: "-10px" }}
								alt="info-icon"
							/>
						</Tooltip>
					</p>
					<Input
						className="otp_user_cssid"
						placeholder="Code"
						style={{ width: "65%" }}
						value={this.state.otp}
						onChange={this.onChangeOtp}
						type="number"
					/>
					{this.state.isCodeIncorrect && !this.state.disableContinue && (
						<p style={{ color: "red" }}>
							Incorrect 2FA code. Re-enter the correct code
						</p>
					)}
					{this.state.disableContinue && (
						<p>
							Incorrect 2FA code.{" "}
							<button
								type="button"
								style={{ color: "blue" }}
								onClick={() => this.onReLogin()}
							>
								Re-login
							</button>{" "}
							again
						</p>
					)}
					<div>
						<br />
						<Button
							className="tfa_btn"
							disabled={this.state.disableContinue}
							type="primary"
							htmlType="submit"
							onClick={this.onSubmit}
						>
							<span className="tfa_text">Continue</span>
						</Button>
					</div>

					{this.state.otp_sent &&
						!this.state.enableResendBtn &&
						!this.state.disableContinue && (
							<p>Email sent! Enter the code above.</p>
						)}

					{this.state.enableResendBtn &&
						this.state.otp_sent &&
						!this.state.disableContinue && (
							<Button
								type="link"
								style={{ color: "orange" }}
								onClick={this.onResendOTP}
							>
								Resend code &#62;
							</Button>
						)}

					{!this.state.enableResendBtn &&
						this.state.otp_sent &&
						!this.state.disableContinue && (
							<p>
								<Button
									type="link"
									style={{ color: "blue" }}
									onClick={this.onReLogin}
								>
									Click here
								</Button>{" "}
								to go back to login screen
							</p>
						)}
				</Card>
			);
		};

		return (
			<div className="signin-page">
				<section className="login">
					<input type="hidden" id="Source" value="NA" />
					<div className="login-right-container" style={{ width: "100%" }}>
						<div className="login-inner-container">
							{/* <div className="signin-announcement-container">
								<div className="signin-announcement-text">
									Factoreal is now part of Satisfi Labs Inc. &nbsp;
									<a
										href="https://satisfilabs.com/expanding-our-platform-satisfi-labs-acquires-factoreal"
										target={"_blank"}
										rel="noreferrer"
									>
										Learn more
									</a>
								</div>
							</div> */}
							<div className="logo-container" style={{ marginBottom: "32px" }}>
								<img
									loading="lazy"
									src={statisfi_back_logo}
									style={{ width: "auto", height: "40px" }}
									alt="satisfi_logo"
								/>
							</div>
							{!this.state.otp_sent ? captchaControls() : tfaControlGrid()}
						</div>
					</div>

					<Loader
						loading={this.state.loading || this.state.pageRedirectionLoading}
					/>
				</section>
			</div>
		);
	}
}

/**
 * Renders the SignIn component with a timeout update function.
 * @param {Object} props - The component props.
 * @returns {JSX.Element} The rendered SignIn component.
 */
function SignInWithTimeout(props) {
	return (
		<TimeoutContext.Consumer>
			{({ timeoutUpdate }) => (
				<SignIn {...props} timeoutUpdate={timeoutUpdate} />
			)}
		</TimeoutContext.Consumer>
	);
}

export default withRouter(SignInWithTimeout);
